import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ClientChange from './ClientChange';
import {
  getAllClients, getAddressClient, setAddressClient
} from "services/redux/sales/corporate/pocDetails/action";

const mapStateToProps = (state) => ({
  clientList: state.pocTypesReducer.getAllClient
  });
  
  const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
      {
        getAllClients,
        getAddressClient,
        setAddressClient
      },
      dispatch
    );
  
  export default connect(mapStateToProps, mapDispatchToProps)(ClientChange);